const { connect } = require('react-redux');
const titleComponent = require('../component/titleComponent').default;
const { actions } = require('../../../reducers').default;
const { modalType } = require('../../../define/screenType').default;
// ============================
const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleTipsClick: () => {
            dispatch(actions.modalEnable(modalType.MODAL_TIPS));
        },
        handleStartClick: () => {
            dispatch(actions.modalEnable(modalType.MODAL_SELECT));
        },
        handleSoundClick: () => {
            dispatch(actions.soundChange());
        }
    };
};

export const TitleContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(titleComponent);